((globalCore) => {

  /**
  * Класс реквизита множественный выбор записей справочника.
  * @namespace Core.requisites
  * @since 5.8.3.9000
  */
  var ReferenceMultiSelect = ReferenceSelectBase.extend({
    /**
    * Конструктор.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceMultiSelect.init
    */
    init: function (inp, options, img) {
      var self = this;
      this._super(inp, options, img);

      self.inp
        .bind('SetValues', function (e, newValues, needTriggerResult) {
          self.setValues(newValues, needTriggerResult);
          self._hidePlaceholder();
        });

      if (self.table) {
        self.table.addClass('rs_multiselect_table');
      }
    },

    /**
    * Функция обработки нажатий на клавиши.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceMultiSelect.process
    * @param {object} e Событие клика.
    */
    process: function (e) {
      ReferenceSelectBase.prototype.process.call(this, e);

      var self = e.data;
      if (self.inp.attr('readonly') || self.inp.attr('disabled')) return;

      if (!(/^13$|^9$/.test(e.keyCode)) && !self.container.is(':visible')) {
        self.inp.data('selected', 'false'); // Значение изменилось.
      }

      // Влево/вправо при множественном выборе
      if (self.multiselect && /^46$|^36$|^35$|^37$|^39$/.test(e.keyCode) && $.trim(self.inp.val()) == '') {
        e.preventDefault();
        e.stopPropagation();
        switch (e.keyCode) {
          case 46: //del
            //Если пользователь удаляет много элементов подряд, то удалим все элементы сразу.
            if (!self.checkLongDeletion()) {
              self.deleteItems(self.inp.next());
            } else {
              self.deleteAllItems();
            };
            break;
          case 36: //home
            self.multiLeft(true);
            break;
          case 35: //end
            self.multiRight(true);
            break;
          case 37: //left
            // Выпадающиего списка нет, то переходим между элементами.
            if (!self.container.is(':visible')) {
              self.multiLeft();
            }
            break;
          case 39: //right
            if (!self.container.is(':visible')) {
              self.multiRight();
            }
            break;
        };
      };

      // Скрытие/раскрытие записей справочника.
      if (self.refcodesCount > 1 && /^37$|^39$/.test(e.keyCode) && self.container.is(':visible')) {
        e.preventDefault();
        e.stopPropagation();
        //left, right
        if (e.keyCode == 37 || e.keyCode == 39) {
          self.selectReference(self.moveReference(0));
        }
      }

      // Backspace работает всегда
      if (/^8$/.test(e.keyCode) && self.inp.val() == '') {
        e.preventDefault();
        e.stopPropagation();
        //Если пользователь удаляет много элементов подряд, то удалим все элементы сразу.
        if (!self.checkLongDeletion()) {
          self.deleteItems(self.inp.prev());
        } else {
          self.deleteAllItems();
        };
      }
    },

    /**
    * Функция проверки долгого нажатия на кнопку Del/Backspace.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceMultiSelect.checkLongDeletion
    * @returns {boolean} True - долгое нажатие.
    */
    checkLongDeletion: function () {
      var self = this;

      // Запомним время первого нажатия кнопки удалить (Del/Backspace).
      if (self._startDeleteTime === null) {
        self._startDeleteTime = $.now();
      };

      //Если прошло 1.5 с. с момента первого нажатия, то это долгое нажатие кнопки удалить.
      if (($.now() - self._startDeleteTime) > 1500) {
        return true;
      };

      // Таймер для сброса времени первого нажатия кнопки удалить.
      if (self._deleteTimeout) clearTimeout(self._deleteTimeout);
      self._deleteTimeout = setTimeout(function () {
        self._startDeleteTime = null;
      }, 300);

      //Не долгое нажатие.
      return false;
    },

    /**
    * Функция получает все выбранные записи.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceMultiSelect.getValues
    * @returns {Array} Массив выбранных записей.
    */
    getValues: function () {
      var self = this;
      var v = [];
      if (self.selectedItems !== null) {
        self.selectedItems.children('span').each(function () {
          var item = $(this);
          var refcode;
          var id = '' + item.data('id');
          var idParts = id.split(':');
          if (idParts.length == 2) {
            refcode = idParts[0];
            id = idParts[1];
          } else {
            refcode = self.getFirstRefCode();
          };
          v.push({
            groupcode: refcode,
            id: id,
            name: '' + item.data('text')
          });
        });
      }
      return v;
    },

    /**
     * Устанавливает 1 значение.
     * @param {any} newValue Новое значение.
     * @param {any} needTriggerResult Признак необходимости вызова события установки значения.
     */
    setValue: function (newValue, needTriggerResult) {
      var self = this;
      ReferenceSelectBase.prototype.setValue.call(this, newValue, needTriggerResult);
      self.changeInpWidthAndPadding();
      setTimeout(function () { //для IE
        self.inp.focus();
      }, 100);
    },

    /**
    * Функция устанавливает множество значений. 
    * Формат [{groupcode:'код справочника', id:'ид записи', name:'наименование'}, ...]
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceMultiSelect.setValues
    * @param {Array} newValues Массив новых значений.
    * @param {boolean} needTriggerResult Признак необходимости вызова события установки значения.
    */
    setValues: function (newValues, needTriggerResult) {
      var self = this;
      var oldHiddVal = self.hidd.val();

      self.deleteAllItems(false);

      var html = '';
      for (var i = 0; i < newValues.length; i++) {
        var val = [];
        val[self.cellIDIndex] = $.trim(newValues[i].groupcode + ':' + newValues[i].id);
        val[self.cellToInput] = $.trim(newValues[i].name);
        if (val[self.cellIDIndex] != '') {
          //Для увеличения скорости работы не вызываем setValue.
          html += self.createNewSelecetedItemHTML(val);
        }
      }
      self.createNewSelecetedItem(null, $(html));
      if (!!needTriggerResult) {
        self.triggerResultEvent(oldHiddVal, newValues);
      }

      self.inp.data('selected', '' + (html != ''));
    },

    /**
    * Функция вызова события установки значения в реквизите множественного выбора.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceMultiSelect.triggerResultEvent
    * @param {string} oldHiddVal Старые значение.
    * @param {string} val Новые значения.
    */
    triggerResultEvent: function (oldHiddVal, val) {
      var self = this;
      if (self.hidd.val() != oldHiddVal) {
        //Шамов А.: Не вызываем триггер result во множественном выборе, т.к. оно перезапишет значение в скрытом поле.
        self.inp.trigger("resultMulti", [val, self.getValues()]);
      }
    },

    /**
    * Событие при нажатии клавиши влево при множественном выборе.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceMultiSelect.multiLeft
    * @param {boolean} toBegin Признак переноса фокуса в начало инпута.
    */
    multiLeft: function (toBegin) {
      var self = this;
      var item;
      if (toBegin) {
        item = self.selectedItems.children('span:first');
      } else {
        item = self.inp.prev();
      }
      item.before(self.inp);

      setTimeout(function () { //для IE
        self.inp.focus();
      }, 100); 

      self.changeInpWidthAndPadding();
    },

    /**
    * Событие при нажатии клавиши вправо при множественном выборе.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceMultiSelect.multiRight
    * @param {boolean} toEnd Признак переноса фокуса в конец инпута.
    */
    multiRight: function (toEnd) {
      var self = this;
      var item;
      if (toEnd) {
        item = self.selectedItems.children('span:last');
      } else {
        item = self.inp.next();
      }
      item.after(self.inp);

      setTimeout(function () { //для IE
       self.inp.focus();
      }, 100);

      self.changeInpWidthAndPadding();
    },

    /**
    * Функция получает результат запроса.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceMultiSelect.getQueryValue
    * @returns {string} Результат запроса.
    */
    getQueryValue: function () {
      var self = this;
      var vs = self.inp.val().split(';');
      var v = vs[vs.length - 1];
      return $.trim(v);
    },

    /**
    * Функция преобразования сообщения.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceMultiSelect.formatMessage
    * @param {string} msg Сообщение.
    * @returns {string} Преобразованное сообщение.
    */
    formatMessage: function (msg) {
      return msg.split('^')[1];
    },

    /**
    * Функция вызова события.
    * since 5.8.3.9000
    * @method Core.requisites.ReferenceMultiSelect.callResult
    */
    callResult() {
      //Шамов А.: Не вызываем триггер result во множественном выборе, т.к. оно перезапишет значение в скрытом поле.
      this.inp.trigger("resultMulti", [null]);
    }
  });

  globalCore.ReferenceMultiSelect = ReferenceMultiSelect;
})(window.Core.requisites);
